// @ts-strict-ignore
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { Route } from 'vue-router'
import type { Store } from 'vuex'

import type { AppRoute, GuardResolveFunction } from '../models'
import { CONTAINER } from '../config'

import { TYPES } from '../config/inversify.types'
import { GuardClass } from '../models'

import { APP_CONSTS } from '../store/app/app.consts'
import { CONFIG_CONSTS } from '../store/config/config.consts'

export class SetFiltersVisibilityGuard extends GuardClass {
  static async execute(
    this: void,
    to: AppRoute,
    from: Route,
    next: GuardResolveFunction,
  ): Promise<void> {
    if (!!to.meta.filters && to.name !== from.name) {
      const store = CONTAINER.get<Store<any>>(TYPES.Store)
      const instanceConfig: Instance =
        store.getters[`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.currentInstance}`]
      const filters = await to.meta.filters(instanceConfig)
      await store.dispatch(
        `${APP_CONSTS.moduleName}/${APP_CONSTS.actions.setFiltersHidden}`,
        !!filters.initiallyHidden,
      )
    }
    next()
  }
}
